import { autoCapitalize } from '@/utils/autoCapitalize'
import { formatCPF } from '@/utils/formatCPF/formatCPF'
import { formatCurrencyBRL } from '@/utils/formatCurrencyBRL'
import { PatientsServiceDetailsListData } from './PatientsServicesDetails.types'
import { PBMMapper } from './PbmMapper/PBMMapper'

class PatientsServicesDetailsMapper {
  toDomain(persistenceData: PatientsServiceDetailsListData) {
    return {
      serviceId: persistenceData?.idAtendimento,
      idAuthorizer: persistenceData?.idAutorizador,
      patientId: persistenceData?.idPaciente,
      patientName: autoCapitalize(persistenceData?.nomePaciente),
      cpf: formatCPF(persistenceData?.cpf),
      phone: persistenceData?.telefone,
      clinic: autoCapitalize(persistenceData?.clinica),
      status: autoCapitalize(persistenceData?.status),
      responsibleProfessionalName: autoCapitalize(
        persistenceData?.nomeProfissionalResponsavel,
      ),
      specialty: autoCapitalize(persistenceData?.especialidade) || '-',
      createProfileUser: autoCapitalize(persistenceData?.perfilUsuarioCriacao),
      createUserName: autoCapitalize(persistenceData?.nomeUsuarioCriacao),
      createDateHour: persistenceData?.dataHoraCriacao,
      createOrigin: autoCapitalize(persistenceData?.origemDaCriacao),
      flagConfirmedAppintment: persistenceData?.flagConsultaConfirmada
        ? 'Sim'
        : 'Não',
      outcomes: autoCapitalize(persistenceData?.desfecho),
      linkNFe: persistenceData?.linkNotaFiscal,
      detailsCallsStatusCanceled:
        persistenceData?.detalhesAtendimentoStatusCanceladoDTO,
      cancelDate: persistenceData?.dataCancelamento,
      cancelCategory: persistenceData?.categoriaCancelamentoDescricao || '',
      cancelReason: persistenceData?.motivoCancelamento || '',
      cancelNameUser: autoCapitalize(persistenceData?.nomeUsuarioCancelamento),
      cancelProfileUser: autoCapitalize(
        persistenceData?.perfilUsuarioCancelamento,
      ),
      userProfileCancellationDescription: autoCapitalize(
        persistenceData?.perfilUsuarioCancelamentoDescricao,
      ),
      userProfileCreationDescription: autoCapitalize(
        persistenceData?.perfilUsuarioCriacaoDescricao,
      ),
      patientPayment: {
        id: persistenceData?.pacientePagamento?.id,
        transactionId: persistenceData?.pacientePagamento?.idTransacao,
        nfeId: persistenceData?.pacientePagamento?.idNFe,
        invoiceNumber: persistenceData?.pacientePagamento?.rps,
        series: persistenceData?.pacientePagamento?.serie,
        issuanceStatus: autoCapitalize(
          persistenceData?.pacientePagamento?.statusEmissao,
        ),
        branch: persistenceData?.pacientePagamento?.filial,
        status: autoCapitalize(persistenceData?.pacientePagamento?.status),
        endCard: persistenceData?.pacientePagamento?.finalCartao || '-',
        flagCard: autoCapitalize(
          persistenceData?.pacientePagamento?.bandeiraCartao,
        ),
        situationPayment: autoCapitalize(
          persistenceData?.pacientePagamento?.situacao || '-',
        ),
        amountPaid: String(
          formatCurrencyBRL(persistenceData?.pacientePagamento?.valorPago),
        ),
        refundUserId: autoCapitalize(
          persistenceData?.pacientePagamento?.idusuarioEstorno,
        ),
        refundUsername: autoCapitalize(
          persistenceData?.pacientePagamento?.nomeUsuarioEstorno || '-',
        ),
        refundDate: persistenceData?.pacientePagamento?.dataEstorno || '-',
        refundReason: autoCapitalize(
          persistenceData?.pacientePagamento?.motivoEstornoDescricao || '-',
        ),
        refundDetails: autoCapitalize(
          persistenceData?.pacientePagamento?.detalheEstorno || '-',
        ),
      },
      calls: persistenceData?.chamadas?.map(item => ({
        callsId: item?.idChamada,
        startDateTime: item?.dataHoraInicio,
        endDateTime: item?.dataHoraFim,
        typeMeeting: autoCapitalize(item?.tipoMeeting),
        duration: item?.duracao,
        patientId: item?.idUsuarioDestinatario,
        professionalId: item?.idUsuarioRemetente,
      })),
      reschedules: persistenceData?.reagendamentos?.map(item => ({
        originalDateTime: item?.dataOriginal,
        rescheduledDateTime: item?.data,
        rescheduleDateTime: item?.dataHoraCadastro,
        responsibleUserProfile: autoCapitalize(item?.origem),
        responsibleUserId: item?.idUsuarioOrigem,
        responsibleUserName: autoCapitalize(item?.nomeUsuarioOrigem),
        responsibleUserIdProfessional: item?.idUsuarioProfissional,
        responsibleUserNameProfessional: autoCapitalize(
          item?.nomeUsuarioProfissional,
        ),
      })),
      ...PBMMapper.map(
        persistenceData.parceiroPbm,
        persistenceData.integradoPbmComSucesso,
      ),
    }
  }
}

export default new PatientsServicesDetailsMapper()
